import Resource from '@/services/resources/common';

export default class GeometryLineResource extends Resource {
  constructor(entrypoint = '/polygons', alias = 'GeometryPolygon') {
    super(entrypoint, alias);
  }
}
